import * as React from 'react'

import { NavigationRoutesFn } from 'modules/core/lib/react-router'

const CompanySelectorPage = React.lazy(
  () => import('modules/authentication/pages/CompanySelectorPage')
)
const RootPage = React.lazy(() => import('modules/authentication/pages/RootPage'))

export const authenticationRoutes: NavigationRoutesFn = (navigation) => {
  return [
    {
      path: navigation.authentication.path,
      element: <RootPage />,
      handle: {
        module: 'authentication',
      },
      children: [
        {
          path: navigation.authentication.company_selector.path,
          element: <CompanySelectorPage />,
        },
      ],
    },
  ]
}
